import gql from 'graphql-tag';

export const RESULTS_QUERY = gql`
  query results {
    results {
      afc: follicleCounts {
        name
        date
        units
        value
      }
      labs {
        type
        name
        date
        units
        value
        normalRange
        category
        categoryDisplayName
        report {
          pdfResults
          htmlResults
        }
      }
      spermAnalyses {
        type
        name
        date
        units
        value
        normalRange
        category
        categoryDisplayName
      }
      homeTestingResults {
        id
        customCode
        createdAt
        pdfLink
        labOrderResultValues {
          shortName
          fullName
          description
          date
          units
          value
          low
          high
          recommendation
        }
      }
    }
    dailyResults {
      date
      follicles {
        date
        name
        type
        units
        value
      }
      labs {
        category
        categoryDisplayName
        date
        name
        normalRange
        type
        units
        value
      }
    }
    retrievalResult {
      attemptType
      eggsRetrieved
      eggsFrozen
      normallyFertilized
      embryosFrozen
      attemptCompleted
    }
  }
`;
